"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var model_1 = require("../diagram/model");
var events_1 = require("../viewUtils/events");
var async_1 = require("../viewUtils/async");
var spinner_1 = require("../viewUtils/spinner");
var CLASS_NAME = 'ontodia-authoring-tools';
var DEFAULT_ELEMENT_TYPE = 'http://www.w3.org/2002/07/owl#Thing';
var AuthoringTools = /** @class */ (function (_super) {
    tslib_1.__extends(AuthoringTools, _super);
    function AuthoringTools(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.listener = new events_1.EventObserver();
        _this.cancellation = new async_1.Cancellation();
        _this.onElementTypeLabelChanged = function () {
            _this.forceUpdate();
        };
        _this.onCreateNewEntity = function () {
            var editor = _this.props.editor;
            var element = editor.createNewEntity(_this.props.selectedElementType.id);
            editor.setSelection([element]);
            editor.showEditEntityForm(element);
        };
        _this.state = {};
        return _this;
    }
    AuthoringTools.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, editor = _a.editor, selectedElementType = _a.selectedElementType;
        this.listener.listen(editor.events, 'changeAuthoringState', function () {
            _this.forceUpdate();
        });
        if (selectedElementType) {
            selectedElementType.events.on('changeLabel', this.onElementTypeLabelChanged);
            this.canCreate(this.props.selectedElementType);
        }
    };
    AuthoringTools.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.selectedElementType !== nextProps.selectedElementType) {
            if (this.props.selectedElementType) {
                this.props.selectedElementType.events.off('changeLabel', this.onElementTypeLabelChanged);
            }
            if (nextProps.selectedElementType) {
                nextProps.selectedElementType.events.on('changeLabel', this.onElementTypeLabelChanged);
            }
        }
    };
    AuthoringTools.prototype.componentDidUpdate = function (prevProp) {
        if (this.props.selectedElementType && this.props.selectedElementType !== prevProp.selectedElementType) {
            this.canCreate(this.props.selectedElementType);
        }
    };
    AuthoringTools.prototype.componentWillUnmount = function () {
        var selectedElementType = this.props.selectedElementType;
        if (selectedElementType) {
            selectedElementType.events.off('changeLabel', this.onElementTypeLabelChanged);
        }
        this.cancellation.abort();
    };
    AuthoringTools.prototype.canCreate = function (selectedElementType) {
        var _this = this;
        var metadataApi = this.props.metadataApi;
        if (!metadataApi) {
            this.setState({ canCreate: false });
        }
        else {
            this.setState({ canCreate: undefined });
            metadataApi.canCreateElement(selectedElementType.id, this.cancellation.signal).then(function (canCreate) {
                if (!_this.cancellation.signal.aborted && _this.props.selectedElementType.id === selectedElementType.id) {
                    _this.setState({ canCreate: canCreate });
                }
            });
        }
    };
    AuthoringTools.prototype.render = function () {
        return (React.createElement("div", { className: CLASS_NAME }, this.renderNewEntityButton()));
    };
    AuthoringTools.prototype.renderNewEntityButton = function () {
        var _a = this.props, view = _a.view, selectedElementType = _a.selectedElementType;
        var canCreate = this.state.canCreate;
        if (!selectedElementType) {
            return React.createElement("div", null, "Select a class to create new entity.");
        }
        var typeLabel = model_1.formatLocalizedLabel(selectedElementType.id, selectedElementType.label, view.getLanguage());
        return (React.createElement("button", { className: "ontodia-btn ontodia-btn-success " + CLASS_NAME + "__create-entity", onClick: this.onCreateNewEntity, disabled: !canCreate }, canCreate === undefined ? React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 }) : (React.createElement("span", null,
            "+ Create new ",
            React.createElement("span", { className: CLASS_NAME + "__type-label" }, typeLabel)))));
    };
    return AuthoringTools;
}(React.Component));
exports.AuthoringTools = AuthoringTools;
